import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { clerkPlugin } from '@clerk/vue'

import './style.css'
import App from './App.vue'

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

// 创建路由
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/sign-in',
      component: () => import('./views/SignIn.vue')
    },
    {
      path: '/sign-up',
      component: () => import('./views/SignUp.vue')
    },
    {
      path: '/callback',
      component: () => import('./views/Callback.vue')
    },
    {
      path: '/auth-extension',
      component: () => import('./views/AuthExtension.vue')
    }
  ]
})

const app = createApp(App)

app.use(router)
app.use(clerkPlugin, {
  publishableKey: clerkPublishableKey
})

app.mount('#app')
